import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { TablesView } from "../features/tables/index.ts";

export const Tables: FC = () => (
  <PageContainer>
    <TablesView />
  </PageContainer>
);
